module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre2",
    attrs: {
      "id": "pgepubid00007"
    }
  }, [_vm._v("CHAPTER III.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre2 sigil_not_in_toc"
  }, [_vm._v("AN EXCESS OF AUTHORITY.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("It was a beautiful moonlight night, and Whittingham was looking her best as we made our way along the avenue leading to the Piazza 1871. The President walked briskly, silent but serene; I followed, the trouble in my mind reflected in a somewhat hang-dog air, and I was not much comforted when the President broke the stillness of the night by saying:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“You have set your foot on the first rung of the ladder that leads to fame and wealth, Mr. Martin.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I was rather afraid I had set it on the first rung of the ladder that leads to the gallows. But there the foot was; what the ladder turned out to be was in the hands of the gods; so I threw off care, and as we entered the Piazza I pointed to the statue and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Behold my inspiring example, your Excellency.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“By Jove, yes!” he replied; “I make the most of my opportunities.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I knew he regarded me as one of his opportunities, and was making the most of me. This is not a pleasant point of view to regard one’s self from, so I changed the subject, and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Shall we call for Don Antonio?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Well, as he’s Minister of Finance, I thought perhaps his presence would make the matter more regular.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“If the presence of the President,” said that official, “can’t make a matter regular, I don’t know what can. Let him sleep on. Isn’t his signature on the bonds enough?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("What could I do? I made one more weak objection:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What shall we tell Jones?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What shall "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("we")]), _vm._v(" tell Jones?” he echoed. “Really, Mr. Martin, you must use your discretion as to what you tell your employees. You can hardly expect me to tell Jones anything, beyond that it’s a fine morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("We had now reached the bank, which stood in Liberty Street, a turning out of the Piazza. I took out my key, unlocked the door, and we entered together. We passed into my inner sanctum, where the safe stood.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“What’s it in?” asked the President.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“United States bonds, and bills on New York and London,” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Good,” said he. “Let me look.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I undid the safe, and took out the securities. He examined them carefully, placing each after due scrutiny in a small handbag, in which he had brought down the bonds I was to receive. I stood by, holding a shaded candle. At this moment a voice cried from the door:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“If you move you’re dead men!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I started and looked up. The President looked up without starting. There was dear old Jones, descended from his upper chamber, where he and Mrs. Jones resided. He was clad only in his night-shirt, and was leveling a formidable gun full at the august head of his Excellency.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Ah, Mr. Jones,” said the latter “it’s a fine morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Good Heavens, the President!” cried Jones; “and Mr. Martin! Why, what on earth, gentlemen—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The President gently waved one hand toward me, as if to say, “Mr. Martin will explain,” and went on placing his securities in the bag.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In face of this crisis my hesitation left me.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I have received a cable from Europe, Jones,” said I, “instructing me to advance a sum of money to his Excellency; I am engaged in carrying out these instructions.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Cable?” said Jones. “Where is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“In my pocket,” said I, feeling for it. “No! Why I must have left it at the Golden House.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The President came to my assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I saw it on the table just before we started. Though I presume Mr. Jones has no "), _c('i', {
    staticClass: "calibre4"
  }, [_vm._v("right")]), _vm._v("—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“None at all,” I said briskly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Yet, as a matter of concession, Mr. Martin will no doubt show it to him to-morrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Strictly as a matter of concession perhaps I will, though I am bound to say that I am surprised at your manner, Mr. Jones.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jones looked sadly puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“It’s all irregular, sir,” said he.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Hardly more so than your costume!” said the President pleasantly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jones was a modest man, and being thus made aware of the havoc the draught was playing with his airy covering, he hastily closed the door, and said to me appealingly:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“It’s all right, sir, I suppose?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Perfectly right,” said I. — “But highly confidential,” added the President. “And you will put me under a personal obligation, Mr. Jones, and at the same time fulfill your duty to your employers, if you preserve silence till the transaction is officially announced. A man who serves me does not regret it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Here he was making the most of another opportunity—Jones this time.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Enough of this,” I said. “I will go over the matter in the morning, and meanwhile hadn’t you better go back to—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Mrs. Jones,” interjected his Excellency. “And mind, silence, Mr. Jones!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("He walked up to Jones as he said this, and looked hard at him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Silent men prosper best, and live longest, Mr. Jones.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Jones looked into his steely eyes, and suddenly fell all of a tremble.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The President was satisfied. He abruptly pushed him out of the room, and we heard his shambling steps going up the staircase.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("His Excellency turned to me, and said with apparent annoyance:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“You leave a great deal to me, Mr. Martin.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("He had certainly done more than tell Jones it was a fine morning. But I was too much troubled to thank him; I was thinking of the cable. The President divined my thoughts, and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“You must prepare that cable.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Yes,” I replied; “that would reassure him. But I haven’t had much practice in that sort of thing, and I don’t quite know—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The President scribbled a few words on a bit of paper, and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Take that to the post office and they’ll give you the proper form; you can fill it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Certainly some things go easily if the head of the state is your fellow-criminal.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“And now, Mr. Martin, it grows late. I have my securities; you have your bonds. We have won over Jones. All goes well. Aureataland is saved. You have made your fortune, for there lie your sixty-five thousand dollars. And, in fine, I am much obliged to you. I will not trouble you to attend me on my return. Good-night, Mr. Martin.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("He went out, and I threw myself down in my office chair, and sat gazing at the bonds he had left me. I wondered whether he had merely made a tool of me; whether I could trust him; whether I had done well to sacrifice my honesty, relying on his promises. And yet there lay my reward; and, as purely moral considerations did not trouble me, I soon arose, put the Government bonds and the sixty-five thousand dollars in securities in the safe, locked up everything, and went home to my lodgings. As I went in it was broad daylight, for the clock had gone five, and I met Father Jacques sallying forth. He had already breakfasted, and was on his way to administer early consolation to the flower-women in the Piazza. He stopped me with a grieved look, and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Ah, my friend, these are untimely hours.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I saw I was laboring under an unjust suspicion—a most revolting thing.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I have only just come from the bank,” I said. “I had to dine at the Golden House and afterward returned to finish up a bit of work.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Ah! that is well,” he cried. “It is, then, the industrious and not the idle apprentice I meet?” referring to a series of famous prints with which my room was decorated, a gift from my father on my departure.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I nodded and passed on, saying to myself: “Deuced industrious, indeed. Not many men have done such a night’s work as I have.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("And that was how my fortunes became bound up with those of the Aureataland national debt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    attrs: {
      "id": "link2HCH0004"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre5",
    attrs: {
      "id": "calibre_pb_7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0